<template>
  <base-print
    title="JOB ORDER SLIP"
    :document-number="'JMBCJOS-' + unit.id + '-23'"
    :document-date="new Date()"
    document-label="No"
    print-id="jobOrderPrint"
  >
    <!-- Customer Information -->
    <h3 style="font-size: 12pt; margin: 10px 0; font-weight: bold">
      PREPARED FOR
    </h3>
    <div class="divider-thin"></div>
    <div class="info-section">
      <p style="margin: 3px 0">{{ unit.customer.customer_name }}</p>
      <p style="margin: 3px 0">
        P-{{ unit.customer.customer_purok }},
        {{ unit.customer.customer_barangay }}
      </p>
      <p style="margin: 3px 0">
        {{ unit.customer.customer_municipality }}, Surigao del Sur
      </p>
      <p style="margin: 3px 0">{{ unit.customer.customer_contact_no }}</p>
    </div>

    <!-- Unit Information -->
    <h3 style="font-size: 12pt; margin: 15px 0 10px 0; font-weight: bold">
      UNIT INFORMATION
    </h3>
    <div class="divider-thin"></div>
    <div class="info-section">
      <div class="info-row">
        <span class="info-label">Type:</span>
        {{ unit.unit_type }}
      </div>
      <div class="info-row">
        <span class="info-label">Brand:</span>
        {{ unit.unit_brand || "N/A" }}
      </div>
      <div class="info-row">
        <span class="info-label">Model:</span>
        {{ unit.unit_model || "N/A" }}
      </div>
      <div class="info-row">
        <span class="info-label">S/N:</span>
        {{ unit.serial_no || "N/A" }}
      </div>
    </div>

    <!-- Initial Problems -->
    <h3 style="font-size: 12pt; margin: 15px 0 10px 0; font-weight: bold">
      INITIAL PROBLEM/S:
    </h3>
    <div
      style="
        border: 1px solid #000;
        padding: 10px;
        min-height: 60px;
        margin-bottom: 15px;
      "
    >
      <p style="margin: 0; white-space: pre-wrap">
        {{ problemDescription }}
      </p>
    </div>

    <!-- Terms and Conditions -->
    <h3 style="font-size: 11pt; margin: 15px 0 10px 0; font-weight: bold">
      Terms and Conditions
    </h3>
    <ol style="font-size: 9pt; margin-left: 15px; line-height: 1.3">
      <li style="margin-bottom: 4px">
        <strong>Liability:</strong> Our business is not liable for any damages,
        external or internal, that may occur to your device after it has been
        removed from our shop, especially if the damage is not related to the
        service we rendered.
      </li>
      <li style="margin-bottom: 4px">
        <strong>Warranty:</strong> After the warranty period has expired, we are
        not obliged to repair or replace items for free. Additional charges may
        apply.
      </li>
      <li style="margin-bottom: 4px">
        <strong>Device Pick-up & Storage:</strong> You'll be notified of pick-up
        via text, email or chat after repair. If not picked up within 15 days,
        daily storage fee of 15 pesos applies. After 3 months, device becomes
        our property.
      </li>
      <li style="margin-bottom: 4px">
        <strong>Diagnostic Fee:</strong> A fee of 450 pesos will be initially
        charged for Laptop/Desktop, and Printer diagnosis. Said amount will be
        deducted to the total amount and other charges due upon pick up. NOTE:
        This is non-refundable.
      </li>
      <li style="margin-bottom: 4px">
        <strong>Mode of Payment:</strong> We accept cash and online payments.
        Downpayments, if required, must be paid before processing of order.
      </li>
      <li style="margin-bottom: 4px">
        <strong>Data Backup:</strong> Backup all important data before repair.
        We are not responsible for data loss.
      </li>
      <li style="margin-bottom: 4px">
        <strong>Changes:</strong> These terms and conditions are subject to
        change at any time without notice.
      </li>
      <li style="margin-bottom: 4px">
        <strong>Acceptance:</strong> By leaving your device for repair, you are
        accepting these terms and conditions.
      </li>
    </ol>

    <!-- Signature Section -->
    <div style="margin-top: 30px">
      <p style="margin: 5px 0; font-size: 10pt">
        I have read, understood, and agree to the terms and conditions stated
        above.
      </p>
      <div style="margin-top: 25px">
        <div
          style="
            border-top: 1px solid #000;
            width: 300px;
            padding-top: 5px;
            text-align: center;
          "
        >
          Customer Signature
        </div>
        <p style="font-size: 9pt; margin-top: 3px">
          Date: {{ formatDate(new Date()) }}
        </p>
      </div>
    </div>
  </base-print>
</template>

<script>
import BasePrint from "./BasePrint.vue";
import moment from "moment";

export default {
  name: "PrintJobOrder",
  components: {
    BasePrint,
  },
  props: {
    unit: {
      type: Object,
      required: true,
    },
  },
  computed: {
    problemDescription() {
      // If problems array exists, join them
      if (this.unit.problems && this.unit.problems.length > 0) {
        return this.unit.problems.map((p) => p.problem_description).join("\n");
      }
      // Otherwise use the problem_description field if available
      return this.unit.problem_description || "No problem description provided";
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("MMMM DD, YYYY");
    },
  },
};
</script>
